module.exports = __webpack_public_path__ + "static/coach-hire-services-college-university-d42ee0473f0ecbb4ec618e060e66cde8.jpg";